<script>
import WaiverResource, { WaiverApprovalResource } from '@/resources/waiver'

export default {
    components: {},
    computed: {
        waiversOutstandingIds() {
            if (!this.waiversOutstanding) {
                return []
            }

            return this.waiversOutstanding.map((resource) => resource.id)
        },
        waiverApprovalsIds() {
            if (!this.waiverApprovals.length) {
                return []
            }

            return this.waiverApprovals.map((resource) => resource.attributes.waiver)
        }
    },
    props: {
        value: {
            required: false,
            type: Object
        },
    },
    watch: {
        async waiver() {
            this.content = ''

            if (this.waiver) {
                this.content = await this.waiver.content()
            }

            this.$emit('input', this.waiver)
        },
        async value() {
            this.waiver = null
            this.$nextTick(() => {
                this.waiver = this.value
            })
        },
        waivers() {
            this.$emit('waivers', this.waivers)
        },
    },
    data() {
        return {
            loading: true,
            content: '',
            waivers: [],
            waiversOutstanding: [],
            waiversApproved: [],
            waiver: this.value
        }
    },
    methods: {
        async load() {
            this.loading = true

            const [waiversAll, waiversOutstandingPageData, waiverApprovals] = await Promise.all([
                WaiverResource.all(),
                WaiverResource.outstanding(),
                WaiverApprovalResource.all()
            ])

            this.waivers = waiversAll || []
            this.waiversOutstanding = waiversOutstandingPageData.resources
            this.waiverApprovals = waiverApprovals
            
            if (this.waiver) {
                await this.waiver.update()
            }

            this.loading = false
            this.$emit('load')
        },
        async onApprove() {
            const approval = await this.waiver.approve()
            this.waiverApprovals.push(approval)

            if (this.waiversOutstandingIds.includes(this.waiver.id)) {
                const index = this.waiversOutstanding.findIndex((waiver) => waiver.id == this.waiver.id)
                this.waiversOutstanding.splice(index, 1)
            }
            
            this.$emit('approve', this.waiver)
            this.next()
        },
        async getOutstanding() {
            const waiversOutstandingPageData = await WaiverResource.outstanding()
            this.waiversOutstanding = waiversOutstandingPageData.resources
            return this.waiversOutstanding
        },
        hasOutstanding() {
            return this.waiversOutstanding.length > 0
        },
        async next() {
            await this.getOutstanding()

            if (this.hasOutstanding()) {
                this.waiver = this.waiversOutstanding[0]
                this.$emit('next')
            } else {
                this.waiver = null
                this.$emit('success')
            }
        },
    },
    async mounted() {
        await this.load()
    }
}
</script>

<template>
    <b-modal v-if="waiver" :title="waiver.attributes.name" :visible="!!waiver" size="lg" @close="waiver = null" hide-footer no-close-on-backdrop no-close-on-esc ok-only no-fade centered>
        <div v-if="content" v-html="content">
        </div>
        <div v-else class="text-center text-muted">
            <b-spinner type="grow" label="Loading..." class="mt-5 mb-5" />
        </div>
        <hr />
        <b-button-group>
            <b-button @click="onApprove()" v-if="!waiverApprovalsIds.includes(waiver.id)">I Agree</b-button>
            <b-button variant="outline-primary" @click="waiver = null">Close</b-button>
        </b-button-group>
    </b-modal>
</template>

<style lang="scss" scoped>
</style>
